import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { frameworksUrl: String }
  static targets = ["agent", "language", "framework", "generate"]

  connect() {
    this.updateGenerateEligibility()
  }

  change(event) {
    if (event?.target === this.languageTarget) {
      this.refreshFrameworkOptions()
    }
    this.updateGenerateEligibility()
  }

  refreshFrameworkOptions() {
    if (!this.hasFrameworksUrlValue) return

    const languageKey = this.languageTarget?.value?.trim()
    const url = new URL(this.frameworksUrlValue, window.location.origin)
    if (languageKey) url.searchParams.set("language_key", languageKey)

    fetch(url.toString(), {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
      .then((response) => response.text())
      .then((html) => {
        if (window.Turbo?.renderStreamMessage) {
          window.Turbo.renderStreamMessage(html)
        }
        this.updateGenerateEligibility()
      })
      .catch(() => {})
  }

  selectLanguage(event) {
    const key = event.currentTarget.dataset.languageKey
    if (!key || !this.hasLanguageTarget) return
    this.languageTarget.value = key
    this.change({ target: this.languageTarget })
  }

  selectAgent(event) {
    const key = event.currentTarget.dataset.agentKey
    if (!key || !this.hasAgentTarget) return
    this.agentTarget.value = key
    this.change({ target: this.agentTarget })
  }

  selectFramework(event) {
    const key = event.currentTarget.dataset.frameworkKey
    if (!this.hasFrameworkTarget) return

    this.frameworkTarget.value = key || ""
    this.change({ target: this.frameworkTarget })
  }

  updateGenerateEligibility() {
    const hasAgent = this.agentTarget?.value?.trim().length > 0
    const hasLanguage = this.languageTarget?.value?.trim().length > 0

    if (this.hasGenerateTarget) {
      this.generateTarget.disabled = !(hasAgent && hasLanguage)
    }
  }
}
